/**
 * Team roster working / not-working — powerful; Liam-only until roles ship.
 * Must match nekoapi TEAM_ROSTER_ADMIN_USERNAMES (see cms/member_roster.py).
 */
export const teamRosterAdminUsernames = ["liam_maneki"];

function normalizeUsername(profile) {
  return String((profile && profile.username) || "")
    .trim()
    .toLowerCase();
}

/** May toggle Working badge, edit-card checkbox, and Timer “Mark working”. */
export function userCanManageTeamRosterStatus(profile) {
  const u = normalizeUsername(profile);
  if (!u) return false;
  return teamRosterAdminUsernames.some(
    (a) => String(a).trim().toLowerCase() === u
  );
}

/** May see “Not currently working” sections and include_not_working lists. */
export function userCanViewInactiveTeamMembers(profile) {
  return userCanManageTeamRosterStatus(profile);
}
